import Platform from "../../../../../../libs/utility/Platform";
import { Theme } from "../../../../../components/constants";

export default {
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginBottom: "30px",
    },
    titleRow: {
        display: "flex",
        flexDirection: "row",
    },
    headerTitle: {
        display: "flex",
        flexDirection: "column",
    },
    titleSubTextContainer: {
        display: "flex",
        flexDirection: "row",
        marginTop: "15px",
        gap: "20px",
        alignItems: "center"
    },
    titleSubText: {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "19px",
        color: Theme.DISABLED_TEXT,
    },
    boxListContainer: {
        display: "flex",
        flexDirection: "column",
        marginTop: "20px",
        flex: 1,
    },
    boxListRow: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "30px",
        flex: 1,
        justifyContent: "center"
    },
    tobeSelectedBoxesContainer: {
        display: "flex",
        flexDirection: "column",
        width: Platform.isMobileView() ? "100%" : "30%",
        gap: "10px",
    },
    selectedBoxesValuesContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        background: Theme.WHITE_BACKGROUND,
        width: Platform.isMobileView() ? "100%" : "65%",
        padding: "30px",
        gap: "20px",
        marginBottom: "30px",
    },
    
    formBox: {
        width: Platform.isMobileView() ? "100%" : "initial",
        maxWidth: "350px"
    },
}